// src/store/searchStore.js

import { create } from 'zustand';

// Создаем Zustand хранилище
const useSearchStore = create((set) => ({
  // Состояние для хранения поискового запроса
  searchQuery: '',

  // Действие для установки поискового запроса
  setSearchQuery: (query) => set({ searchQuery: query }),

  // Действие для очистки поискового запроса
  clearSearchQuery: () => set({ searchQuery: '' }),
}));

export default useSearchStore;
